export default __webpack_public_path__ + "fonts/ubuntu-latin-400-normal-2f02ef.woff2";